import {NodeSpec} from 'prosemirror-model';

export const math_inline: NodeSpec = {
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {latex: {default: ''}},
    parseDOM: [{
        tag: 'span[data-math-inline]',
        getAttrs: (dom) => ({latex: (dom as HTMLElement).getAttribute('data-math-inline') ?? ''}),
    }],
    toDOM: (node) => ['span', {'data-math-inline': node.attrs.latex}],
};
